import {createSlice} from '@reduxjs/toolkit';
import {CaseTreatmentMaterialDto} from 'src/shared/services/case-treatment-materials/dto/case-material-dto';

interface caseTreatmentMaterialInitialState {
  caseTreatmentMaterialDetails: CaseTreatmentMaterialDto | undefined;
}

const initialState: caseTreatmentMaterialInitialState = {
  caseTreatmentMaterialDetails: undefined,
};

const caseTreatmentMaterialSlice = createSlice({
  name: 'caseTreatmentMaterial',
  initialState: initialState,
  reducers: {
    setCaseTreatmentMaterialDetails: (state, action) => {
      state.caseTreatmentMaterialDetails = action.payload;
    },
  },
});

export const {setCaseTreatmentMaterialDetails} =
  caseTreatmentMaterialSlice.actions;

export default caseTreatmentMaterialSlice.reducer;
